export const carouselFragment = `
  fragment carouselFragment on CarouselRecord {
    button {
      ...buttonFragment
    }
    cards {
      __typename
      ... on CarouselCardListRecord {
        visibleCards
        cards {
          ...cardFragment
        }
      }
      ... on CarouselUserListRecord {
        visibleCards
        cards {
          ...userCardFragment
        }
      }
    }
    filterField
    filterPlaceholder
    headingProps {
      textStyle
    }
    moduleFormat{
      ...moduleFormatFragment
    }
    smallScreenCardDirection
    subtitle
    title
  }
`;
